export const validateNumber = (input: string) => {
  const validRegex = /^[1-9]{1}\d*$/;
  return validRegex.test(input);
};
